export default __webpack_public_path__ + "static/media/hoso-maki-sake.13cbad5b.jpg";